import { Trans } from '@lingui/react/macro';
import { createFileRoute, Outlet, Link } from '@tanstack/react-router';
import { Layout } from '@utima/ui';

import logo from '@/assets/images/logo-black.svg';
import { LanguageSwitcher } from '@/components/languageSwitcher/LanguageSwitcher';
import { Menu } from '@/components/menu/Menu';
import { UserDropdown } from '@/components/userDropdown/UserDropdown';
import { UsageLimitBanner } from '@/features/organizations/components/UsageLimitBanner';
import { useUserMeData } from '@/features/users/useUserMeData';
import { useCurrentOrganization } from '@/hooks/useCurrentOrganization';

export const Route = createFileRoute('/_baseLayout')({
  beforeLoad: async ({ context: { authGuard } }) => authGuard(),
  component: BaseLayout,
});

export function BaseLayout() {
  const { organization, isError, isContextMismatch, refetch } =
    useCurrentOrganization();

  if (!organization) {
    return (
      <div
        className='flex min-h-screen flex-col items-center justify-center gap-4'
        role='status'
      >
        {isError || isContextMismatch ? (
          <>
            <p>
              <Trans>Unable to load the current organization.</Trans>
            </p>
            <button
              type='button'
              onClick={() => void refetch()}
              className='underline'
            >
              <Trans>Try again</Trans>
            </button>
          </>
        ) : (
          <p>
            <Trans>Loading organization…</Trans>
          </p>
        )}
      </div>
    );
  }

  return <OrganizationLayout />;
}

function OrganizationLayout() {
  useUserMeData();

  return (
    <Layout.Root hasHeader={false} headerHeight={0}>
      <Layout.Sidebar className='flex flex-col justify-between border-r p-3 text-foreground'>
        <div>
          <div className='mx-1 my-2 mb-3 flex items-center justify-between'>
            <Link to='/' className='block p-1'>
              <img src={logo} alt='Kanbu.ai' className='h-8 w-auto' />
            </Link>
            <div>
              <LanguageSwitcher />
            </div>
          </div>
          <Menu />
        </div>
        <UserDropdown />
      </Layout.Sidebar>
      <Layout.Content className='bg-gray-50 p-6'>
        <div className='container mx-auto'>
          <UsageLimitBanner />
          <Outlet />
        </div>
      </Layout.Content>
    </Layout.Root>
  );
}
